import styled, { css } from 'styled-components';
import DefaultSelect from 'components/Form/Select';
import DefaultSpinner from 'components/Spinner';
import addAlpha from 'utils/addAlpha';
import { StyleProps } from './types';

// TODO: TFR-45:Select make unique name or do not export
export const Select = styled(DefaultSelect)<StyleProps>`
  ${({ $mode }) => {
    switch ($mode) {
      case 'item': {
        return css`
          float: right;

          &.MuiInputBase-root {
            border-radius: 1.5rem;
            padding: 0.75rem 1.25rem;
            height: 3rem;
            width: fit-content;
            justify-self: flex-end;
          }
        `;
      }
      case 'modifier':
      default: {
        return css`
          &.MuiInputBase-root {
            border-radius: 0.75rem;
          }
        `;
      }
    }
  }}

  &.MuiInputBase-root {
    font-family: Gilroy;
    font-size: 1.0625rem;
    line-height: 1.5rem;
    font-weight: 500;
  }

  .MuiSelect-select.MuiSelect-select {
    padding-right: 1.575rem;

    &:focus,
    &:active {
      background: inherit;
    }
  }

  .MuiSelect-icon {
    right: 1rem;
    top: 1rem;
    width: 1rem;
    height: 1rem;
  }

  ${({ value, theme }) => {
    switch (value) {
      case 'SUSPEND_DAY':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.yellowLight};
            color: ${theme.colors.yellowDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.yellowDark};
          }
        `;
      case 'ACTIVE':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.greenExtraLight};
            color: ${theme.colors.greenDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.greenDark};
          }
        `;
      default:
      case 'SUSPEND_INDEFINITE':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.redExtraLight};
            color: ${theme.colors.redDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.redDark};
          }
        `;
    }
  }}
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Spinner = styled(DefaultSpinner)``;

export const Chip = styled.span<StyleProps>`
  font-size: 1.0625rem;
  line-height: 1.5rem;
  font-weight: 500;
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;

  background-color: ${({ theme }) => theme.colors.navyGreenLight};
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};

  ${({ $mode }) => {
    switch ($mode) {
      case 'item': {
        return css`
          border-radius: 1.5rem;
          height: 3rem;
          float: right;
        `;
      }
      case 'modifier':
      default: {
        return css`
          border-radius: 0.75rem;
          height: 3.5rem;
        `;
      }
    }
  }}
`;
